module.exports = __webpack_public_path__ + "img/pre_filtrage_residentielle.330b606a.jpg";